import Signal from 'signal-js';
import { mix } from '@immutabl3/utils';
import PositionStore from './PositionStore.js';
import { getSign } from './util.js';
const event = {
    xSpeed: -1,
    ySpeed: -1,
    xDistance: -1,
    yDistance: -1,
};
export default function EndInertiaUtil(endTimeRange = 200, xDecelerationPerSecond = Infinity, yDecelerationPerSecond = Infinity, xMaxSpeed = Infinity, yMaxSpeed = Infinity, speedScale = 1) {
    let timer = -1;
    const signal = Signal();
    const xPositionStore = PositionStore(endTimeRange);
    const yPositionStore = PositionStore(endTimeRange);
    const dealOriginalSpeed = (speed, maxSpeed) => {
        if (Math.abs(speed) > maxSpeed)
            return getSign(speed) * maxSpeed;
        return speed;
    };
    return mix(signal, {
        isRunning() {
            return timer !== -1;
        },
        // push a move position
        // it will be used to calculate the end speed
        push(positionX, positionY) {
            xPositionStore.push(positionX);
            yPositionStore.push(positionY);
        },
        // end a series of position push and start to calculate inertia
        // move distance and emit "inertiaMove" event
        end() {
            if (timer !== -1)
                cancelAnimationFrame(timer);
            const originalXSpeed = dealOriginalSpeed(xPositionStore.getEndSpeed(), xMaxSpeed);
            const originalYSpeed = dealOriginalSpeed(yPositionStore.getEndSpeed(), yMaxSpeed);
            const xdps = getSign(originalXSpeed) === 0 ? 0 : getSign(originalXSpeed) * xDecelerationPerSecond;
            const ydps = getSign(originalYSpeed) === 0 ? 0 : getSign(originalYSpeed) * yDecelerationPerSecond;
            let xSpeed = originalXSpeed * speedScale;
            let ySpeed = originalYSpeed * speedScale;
            let time = Date.now();
            const loop = () => {
                const pastSeconds = (Date.now() - time) / 1000;
                xSpeed = xSpeed - pastSeconds * xdps;
                ySpeed = ySpeed - pastSeconds * ydps;
                time = Date.now();
                if (xSpeed * originalXSpeed > 0 || ySpeed * originalYSpeed > 0) {
                    if (Number.isNaN(xSpeed * originalXSpeed) || xSpeed * originalXSpeed < 0) {
                        xSpeed = 0;
                    }
                    if (Number.isNaN(xSpeed * originalYSpeed) || ySpeed * originalYSpeed < 0) {
                        ySpeed = 0;
                    }
                    event.xSpeed = xSpeed;
                    event.ySpeed = ySpeed;
                    event.xDistance = xSpeed * pastSeconds;
                    event.yDistance = ySpeed * pastSeconds;
                    signal.emit('inertiaMove', event);
                    timer = requestAnimationFrame(loop);
                }
                else {
                    this.stop();
                }
            };
            timer = requestAnimationFrame(loop);
        },
        // stop the inertia move.
        // it also stops the "inertiaMove" event
        stop() {
            xPositionStore.clear();
            yPositionStore.clear();
            cancelAnimationFrame(timer);
            timer = -1;
        },
    });
}
;
//# sourceMappingURL=EndInertiaUtil.js.map